// stateSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface StateSlice {
  /** Start date (inclusive). Null means "no lower bound". */
  fromDate: string | null;
  /** End date (inclusive). Null means "today". */
  toDate: string | null;
  appName: string;
}

const initialState: StateSlice = {
  fromDate: null,
  toDate: new Date().toISOString(),
  appName: "",
};

const stateSlice = createSlice({
  name: "state",
  initialState,
  reducers: {
    setFromDate(state, action: PayloadAction<string | null>) {
      state.fromDate = action.payload;
    },
    setToDate(state, action: PayloadAction<string | null>) {
      state.toDate = action.payload;
    },
    setAppName(state, action: PayloadAction<string>) {
      state.appName = action.payload;
    },
  },
});

export const { setFromDate, setToDate, setAppName } = stateSlice.actions;
export const stateReducer = stateSlice.reducer;
